// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import axios from './http/http'
// import moment from 'moment'
import {Format} from './common/js/time.js'
import fastclick from 'fastclick'
import router from './router'

// 移除移动端点击延迟
fastclick.attach(document.body)
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)
Vue.use(Mint)

import vuePicturePreview from 'vue-picture-preview'

Vue.use(vuePicturePreview)
import './common/sass/index.scss'

Vue.config.productionTip = false
Vue.prototype.$http = axios;

// Vue.filter('dateFmt', (input, dateFmtString) => {
//   const lastFmtString = dateFmtString || 'YYYY-MM-DD HH:mm:ss'
//   return moment(input).format(lastFmtString)
// })
// import {getCookie, setCookie, delCookie} from './common/js/cookies.js'
// Vue.prototype.$cookieStore = {
//   getCookie,
//   setCookie,
//   delCookie
// }
(function () {
  if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
    handleFontSize()
  } else {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handleFontSize)
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', {'font-size': 0})
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', {'font-size': 0})
    })
  }
})()
// 允许vue使用自定义标签
Vue.config.ignoredElements = [
  'wx-open-launch-weapp'
]

Vue.filter('dateFmt', (time, fmt) => {
  return Format(time, fmt)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js